import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../resources/Constants";
import logo from "../../../resources/img/smileweb.png";
import "./Login2.css";

const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
});

function NewUser() {
    const [mensaje, setMensaje] = useState(
        "Para activar tu cuenta, revisa tu bandeja de entrada y haz clic en el enlace que enviamos a tu correo."
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [uid, setUid] = useState("");
    const [envioOk, setEnvioOk] = useState(false);
    const [mensajeOk, setMensajeOk] = useState("");

    useEffect(() => {
        if (localStorage.getItem("userdata")) {
            const userdata = JSON.parse(localStorage.getItem("userdata"));
            setUid(String(userdata.user_id || ""));
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!uid) {
            setEnvioOk(false);
            setError("No se encontró sesión de usuario. Inicia sesión de nuevo para reenviar el correo.");
            return;
        }
        setError("");
        setEnvioOk(false);
        setMensajeOk("");
        setLoading(true);

        axiosInstance
            .get("/send-activation-link?uid=" + encodeURIComponent(uid))
            .then((response) => {
                setLoading(false);
                setEnvioOk(true);
                setMensajeOk(
                    response.data.message ||
                        "Listo: le enviamos un nuevo correo con el enlace de activación. Revise también spam o promociones."
                );
            })
            .catch((err) => {
                setLoading(false);
                setEnvioOk(false);
                const msg =
                    err.response?.data?.message ||
                    "No se pudo enviar el correo. Intenta más tarde o contacta a soporte.";
                setError(msg);
            });
    };

    return (
        <div className="login-container">
            <style>{`
                .newuser-hero-icon {
                    width: 56px;
                    height: 56px;
                    margin: 0 auto 18px;
                    border-radius: 14px;
                    background: linear-gradient(135deg, rgba(23, 162, 184, 0.14) 0%, rgba(46, 65, 78, 0.1) 100%);
                    border: 1px solid rgba(23, 162, 184, 0.22);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .newuser-hero-icon i {
                    font-size: 1.4rem;
                    color: #117a8b;
                }
                .newuser-message {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 16px 18px;
                    font-size: 15px;
                    line-height: 1.55;
                    color: #334155;
                    text-align: center;
                    margin-bottom: 22px;
                }
                .newuser-hint {
                    font-size: 13px;
                    color: #64748b;
                    text-align: center;
                    line-height: 1.45;
                    margin-bottom: 20px;
                }
                .btn-login.btn-outline-auth {
                    background: #fff;
                    color: #2E414E;
                    border: 2px solid #e2e8f0;
                    margin-top: 0;
                }
                .btn-login.btn-outline-auth:hover:not(:disabled) {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                    box-shadow: 0 4px 12px rgba(46, 65, 78, 0.12);
                    transform: translateY(-1px);
                }
            `}</style>

            <div className="login-card">
                <div className="login-logo">
                    <img src={logo} alt="SmileWEB" />
                </div>

                <div className="newuser-hero-icon" aria-hidden="true">
                    <i className="fas fa-envelope-open-text"></i>
                </div>

                <h1 className="login-title" style={{ fontSize: "22px" }}>
                    Activa tu cuenta
                </h1>
                <p className="login-subtitle" style={{ marginBottom: "18px" }}>
                    Falta un último paso: confirma tu correo electrónico para comenzar a usar SmileWEB.
                </p>

                <div className="newuser-message">{mensaje}</div>

                {envioOk ? (
                    <div className="alert alert-success" role="status" aria-live="polite">
                        <i className="fas fa-check-circle mr-2" aria-hidden="true"></i>
                        {mensajeOk}
                    </div>
                ) : null}

                {error ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive">
                        {error}
                    </div>
                ) : null}

                <p className="newuser-hint">
                    ¿No llegó el correo? Revisa spam o promociones. También puedes solicitar un nuevo enlace.
                </p>

                <form onSubmit={handleSubmit} noValidate>
                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Enviando…
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane mr-2"></i>
                                Reenviar correo de activación
                            </>
                        )}
                    </button>
                </form>

                <div className="login-links" style={{ flexWrap: "wrap", gap: "12px" }}>
                    <Link to="/login" className="login-link">
                        <i className="fas fa-arrow-left"></i>
                        Volver al inicio de sesión
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default NewUser;
